module.exports = __webpack_public_path__ + "img/2.2ba50283.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":838,"height":504,"variants":[{"file":"img/2-480w.eece69271e79.webp","width":480},{"file":"img/2-838w.7744c4628642.webp","width":838}]};
}